import { render } from "./LeadDrawer.vue?vue&type=template&id=6b2b1776&scoped=true"
import script from "./LeadDrawer.vue?vue&type=script&lang=js"
export * from "./LeadDrawer.vue?vue&type=script&lang=js"

import "./LeadDrawer.vue?vue&type=style&index=0&id=6b2b1776&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2b1776"]])

export default __exports__